module.exports = __webpack_public_path__ + "static/img/sign.c31f6f84.png";